<template>
<div class="chapter">
<div class="inner_page">
<a id="pagei">
<h1 class="half-title">The Battle of Fontenoy 1745</h1>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Halftitle.vue?a1af3c80